export const DIRECTORIES_COMPANY_NAME = 'directories.company.structure';
